module.exports = __webpack_public_path__ + "img/SKMJ_check2.d93f7dbd.png";